import WasmController from "react-lib/frameworks/WasmController";

// Sequence
import * as ProjectList from "./sequence/ProjectList";
import * as IssueList from "./sequence/IssueList";

export type State = ProjectList.State &
  IssueList.State;

export type Props = {};

export type Event =
  | ProjectList.Event
  | IssueList.Event;

export type Data = 
  ProjectList.Data &
  IssueList.Data;

export const StateInitial: State = {};

export const DataInitial = {
  ...ProjectList.DataInitial,
  ...IssueList.DataInitial,
};

